import axios from "axios";

export const SuccessStoriesAPI={
    get:function() {
        return axios({
            method:'GET',
            url:`${process.env.REACT_APP_API_URL}/get-testimonials`,
        })
    }
}